var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortuneToolbarWidgetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 10A4.25 4.25 0 0112 5.75a.75.75 0 000-1.5A5.75 5.75 0 006.25 10a.75.75 0 001.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 10c0 3.69-2.22 6.86-5.397 8.25H18.5a2.25 2.25 0 010 4.5h-13a2.25 2.25 0 010-4.5h2.897A9 9 0 1121 10zm-9 7.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm-6.5 2.25a.75.75 0 000 1.5h13a.75.75 0 000-1.5h-13z"
  })));
}
export default SvgFortuneToolbarWidgetIcon;